module.exports = __webpack_public_path__ + "static/media/login-image.50aa3e85.png";